import { Box, Divider, Grid, Paper, Tab, Tabs } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
class FuReportMobile extends Component {
    state = { 
        selectedTab: "PERJAM"
    } 

    handleSelectedTabChange = (event, newValue) => {
        this.setState({selectedTab: newValue});
    };

    render() { 
        return (
            <Box>
                <NavbarMobile title={"FU Report Tele"} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    <Filter {...this.props} />
                    <Box>
                        {this.props.state.contactLeads?.map(lead => {
                            return (
                            <Box elevation={2} sx={{mb: "5px", padding: "5px"}}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <strong>{lead.salesName}</strong>
                                    </Grid>
                                    <Grid item xs={4} textAlign={"left"}>
                                        Total<br />
                                        <strong>{lead.fromLavender.length + lead.fromHsm.length}</strong>
                                    </Grid>
                                    <Grid item xs={4} textAlign={"center"}>
                                        FU Lavender<br />
                                        <strong>{lead.fromLavender.length}</strong>
                                    </Grid>
                                    <Grid item xs={4} textAlign={"right"}>
                                        FU HSM<br />
                                        <strong>{lead.fromHsm.length}</strong>
                                    </Grid>
                                </Grid>
                                <Divider sx={{mt: "8px"}} />
                            </Box>
                            );
                        })}
                    </Box>
                </Box>
            </Box>
        );
    }
}
 
export default FuReportMobile;